import React, { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Close.module.scss';

const CloseButton = forwardRef(({
  onClick,
  className,
  children,
  ...props
}, ref) => (
  <button
    ref={ref}
    type="button"
    className={cn(styles.button, className)}
    onClick={onClick}
    {...props}
  >
    <i className="la la-times-circle" />{children}
  </button>
));

CloseButton.displayName = 'forwardRef(CloseButton)';

CloseButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node
};

CloseButton.defaultProps = {
  onClick() {},
  className: '',
  children: null
};

export default CloseButton;
